// Mock data for Lucimar Bizoni website

export const heroData = {
  announcement: "Transformando vidas através da Palavra",
  title: "Lucimar Bizoni",
  subtitle: "Ministra do Evangelho • Conferencista • Educadora Financeira • Psicoterapeuta Cristã",
  description: "Uma voz ativa na formação de líderes cristãos, dedicada a orientar, inspirar e transformar pessoas pelos princípios bíblicos em todas as áreas: espírito, alma e corpo.",
  ctaPrimary: "Agende uma Consultoria",
  ctaSecondary: "Conheça os Projetos"
};

export const aboutData = {
  title: "Sobre Lucimar",
  subtitle: "Uma trajetória de fé, propósito e transformação",
  bio: [
    "Ministra do Evangelho, Conferencista, Administradora, Pós-graduada em Recursos Humanos, Neurociência e Desenvolvimento Humano.",
    "Psicoterapeuta Cristã, Escritora, Analista Comportamental e Educadora Financeira.",
    "Casada com Jorge Bizoni, mãe de Daniel Lucas e João."
  ],
  experience: [
    {
      title: "21+ Anos",
      description: "Experiência no mercado financeiro"
    },
    {
      title: "1000+ Líderes",
      description: "Formados através do ministério"
    },
    {
      title: "15+ Anos",
      description: "Liderando o Projeto Divas"
    },
    {
      title: "Desde 2012",
      description: "Diretora do CTB Rhema Brasil"
    }
  ],
  roles: [
    "Diretora e professora do Centro de Treinamento Bíblico Rhema Brasil em Vitória/ES",
    "Vice-presidente da Igreja Verbo da Vida em Vitória/ES",
    "Fundadora do Projeto Divas",
    "Líder do Projeto Águias",
    "Líder do Projeto Prospere - Negócios com Deus"
  ],
  mission: "Orientar, inspirar e transformar pessoas pelos princípios bíblicos da Palavra de Deus em todas as áreas: espírito, alma e corpo."
};

export const servicesData = {
  title: "Consultoria & Mentoria",
  subtitle: "Serviços especializados para sua transformação integral",
  services: [
    {
      id: 1,
      title: "Consultoria Financeira Cristã",
      description: "Educação financeira baseada na Bíblia, com princípios eternos para prosperidade com propósito.",
      features: [
        "Planejamento financeiro com propósito",
        "Mentoria para pessoas físicas",
        "Mentoria para empresários",
        "Princípios bíblicos de prosperidade"
      ],
      accent: "purple"
    },
    {
      id: 2,
      title: "Psicoterapia Cristã",
      description: "Acompanhamento emocional e espiritual integrando fé, neurociência e desenvolvimento humano.",
      features: [
        "Desenvolvimento humano integral",
        "Acompanhamento emocional",
        "Análise comportamental",
        "Neurociência aplicada à fé"
      ],
      accent: "blue"
    },
    {
      id: 3,
      title: "Psicopedagogia",
      description: "Suporte especializado para desenvolvimento cognitivo e emocional com base em princípios cristãos.",
      features: [
        "Avaliação psicopedagógica",
        "Intervenção personalizada",
        "Orientação familiar",
        "Desenvolvimento de potenciais"
      ],
      accent: "orange"
    }
  ]
};

export const projectsData = {
  title: "Projetos",
  subtitle: "Iniciativas que transformam vidas e fortalecem identidades",
  projects: [
    {
      id: 1,
      name: "Projeto Divas",
      tagline: "Resgatando a identidade feminina",
      description: "Há mais de 15 anos, o Projeto Divas resgata e fortalece a identidade feminina, ajudando mulheres a descobrirem seu valor e propósito em Deus.",
      audience: "Mulheres que buscam autoconhecimento e fortalecimento espiritual",
      accent: "pink"
    },
    {
      id: 2,
      name: "Projeto Águias",
      tagline: "Voando alto com firmeza e constância",
      description: "Visa o despertar e o posicionamento de mulheres para uma vida de firmeza, constância e abundância, desenvolvendo liderança e propósito.",
      audience: "Mulheres em busca de crescimento e posicionamento",
      accent: "blue"
    },
    {
      id: 3,
      name: "Projeto Prospere",
      tagline: "Negócios com Deus",
      description: "Capacita empresários e empreendedores à luz da Palavra, unindo princípios bíblicos com estratégias práticas de negócios.",
      audience: "Empresários e empreendedores cristãos",
      accent: "green"
    }
  ]
};

export const lecturesData = {
  title: "Palestras & Conferências",
  subtitle: "Mensagens transformadoras para sua igreja, empresa ou evento",
  themes: [
    "Finanças à luz da Palavra",
    "Identidade feminina em Cristo",
    "Liderança com propósito",
    "Neurociência e fé",
    "Desenvolvimento humano integral",
    "Empreendedorismo cristão",
    "Família e relacionamentos",
    "Prosperidade com princípios"
  ],
  audiences: [
    "Igrejas e ministérios",
    "Conferências femininas",
    "Eventos empresariais",
    "Congressos de liderança",
    "Seminários de desenvolvimento"
  ],
  testimonials: [
    {
      id: 1,
      quote: "A ministração da Lucimar transformou minha visão sobre finanças e propósito. Hoje tenho uma empresa próspera baseada em princípios bíblicos.",
      author: "Maria Helena",
      role: "Empresária"
    },
    {
      id: 2,
      quote: "O Projeto Divas foi um divisor de águas na minha vida. Redescobri minha identidade e valor como mulher de Deus.",
      author: "Ana Paula",
      role: "Participante do Projeto Divas"
    },
    {
      id: 3,
      quote: "As palestras sobre liderança da Lucimar são profundas e práticas. Impactaram toda nossa equipe ministerial.",
      author: "Pastor Roberto",
      role: "Igreja Batista Central"
    }
  ]
};

export const contentData = {
  title: "Conteúdos",
  subtitle: "Artigos e mensagens para seu crescimento",
  articles: [
    {
      id: 1,
      title: "Os 7 Princípios Bíblicos da Prosperidade",
      excerpt: "Descubra os fundamentos eternos para uma vida financeira abençoada segundo a Palavra de Deus.",
      category: "Finanças",
      date: "2025-07-15"
    },
    {
      id: 2,
      title: "Identidade: Quem Deus Diz Que Você É",
      excerpt: "Uma reflexão profunda sobre como a Palavra define nossa verdadeira identidade em Cristo.",
      category: "Desenvolvimento",
      date: "2025-07-10"
    },
    {
      id: 3,
      title: "Neurociência da Fé: Como a Crença Transforma o Cérebro",
      excerpt: "A ciência confirma o poder da fé na transformação mental e emocional.",
      category: "Neurociência",
      date: "2025-07-05"
    }
  ],
  devotionals: [
    {
      id: 1,
      title: "Confiança no Senhor",
      verse: "Confia no Senhor de todo o teu coração... - Provérbios 3:5-6",
      date: "2025-08-01"
    },
    {
      id: 2,
      title: "Força e Coragem",
      verse: "Seja forte e corajoso! Não se apavore... - Josué 1:9",
      date: "2025-07-30"
    }
  ]
};

export const contactData = {
  title: "Entre em Contato",
  subtitle: "Estou pronta para ajudar você em sua jornada de transformação",
  email: "contato@lucimarbizoni.com.br",
  phone: "+55 27 99911-8293",
  whatsapp: "+55 27 99911-8293",
  address: "Vitória - ES, Brasil",
  social: {
    instagram: "lucimarbizoni",
    facebook: "lucimarbizoni",
    youtube: "lucimarbizoni"
  },
  formFields: [
    { name: "name", label: "Nome completo", type: "text", required: true },
    { name: "email", label: "E-mail", type: "email", required: true },
    { name: "phone", label: "Telefone/WhatsApp", type: "tel", required: true },
    { name: "subject", label: "Assunto", type: "select", options: [
      "Consultoria Financeira",
      "Psicoterapia Cristã",
      "Palestras e Conferências",
      "Projeto Divas",
      "Projeto Águias",
      "Projeto Prospere",
      "Outro"
    ], required: true },
    { name: "message", label: "Mensagem", type: "textarea", required: true }
  ]
};

export const navigationData = {
  logo: "Lucimar Bizoni",
  links: [
    { label: "Início", href: "#hero" },
    { label: "Sobre", href: "#about" },
    { label: "Serviços", href: "#services" },
    { label: "Ferramentas", href: "#tools" },
    { label: "Projetos", href: "#projects" },
    { label: "Palestras", href: "#lectures" },
    { label: "Contato", href: "#contact" }
  ],
  cta: "Agende Agora"
};

export const footerData = {
  copyright: "© 2025 Lucimar Bizoni. Todos os direitos reservados.",
  tagline: "Transformando vidas através da Palavra de Deus",
  quickLinks: [
    { label: "Consultoria Financeira", href: "#services" },
    { label: "Psicoterapia Cristã", href: "#services" },
    { label: "Projeto Divas", href: "#projects" },
    { label: "Palestras", href: "#lectures" }
  ]
};

export const impactData = {
  title: "Impacto que Transforma",
  subtitle: "Números que refletem uma vida dedicada ao Reino",
  stats: [
    { value: 21, suffix: '+', label: 'Anos de Experiência', description: 'No mercado financeiro e ministério', accent: 'purple' },
    { value: 1000, suffix: '+', label: 'Líderes Formados', description: 'Através do CTB Rhema Brasil', accent: 'blue' },
    { value: 15, suffix: '+', label: 'Anos de Projeto Divas', description: 'Resgatando identidades femininas', accent: 'pink' },
    { value: 500, suffix: '+', label: 'Palestras Realizadas', description: 'Em igrejas e empresas', accent: 'orange' }
  ]
};
